import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@mui/styles";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import "react-daterange-picker/dist/css/react-calendar.css";
import spinner from '../../assign-prescriptions/images/spinner.gif';
import Typography from "@mui/material/Typography";
import moment from 'moment-timezone';
import {withTranslation} from "react-i18next";
import {getDefaultDateRange, getDateRangeByPreset, formatFromDateForAPI, formatToDateForAPI} from "../../../utils/datetime.utils";
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import ILocalAGGrid, {
    getDefaultColDef,
    createServerSideDatasource,
    withDateColumnFilter,
    applyReportFilterModel,
    attachReportServerSideDatasource,
  PHARMACY_REPORT_SORT_MAP,
} from "../../grid/iLocalAGGrid";

function TabContainer({ children, dir, classes }) {
    return (
        <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
            {children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
    dir: PropTypes.string.isRequired,
};

class EnhancedTableHead extends React.Component {
    createSortHandler = (property, field) => event => {
        this.props.onRequestSort(event, property, field);
    };

    render() {
        const {order, orderBy, sortId, t} = this.props;
        const rows = [
            { id: "order_id", numeric: false, disablePadding: false, label: t("Report.OrderStaging.OrderID"), padding: '10px', field: 'order_id' },
            { id: "order_timestamp", numeric: false, disablePadding: false, label: t("Report.OrderStaging.OrderTimestamp"), padding: '10px', field: 'order_timestamp' },
            { id: "store_ncpdp", numeric: false, disablePadding: false, label: t("Report.OrderStaging.StoreNCPDP"), padding: '10px', field: 'store_ncpdp' },
            { id: "patient_id", numeric: false, disablePadding: false, label: t("Report.OrderStaging.PatientID"), padding: '10px', field: 'patient_id' },
            { id: "first_name", numeric: false, disablePadding: false, label: t("Report.OrderStaging.FirstName"), padding: '10px', field: 'first_name' },
            { id: "last_name", numeric: false, disablePadding: false, label: t('Report.OrderStaging.LastName'), padding: '10px', field: 'last_name' },
            { id: "gender", numeric: false, disablePadding: false, label: t("Report.OrderStaging.Gender"), padding: '10px', field: 'gender' },
            { id: "dob", numeric: false, disablePadding: false, label: t("Report.OrderStaging.DOB"), padding: '10px', field: 'dob' },
            { id: "email", numeric: false, disablePadding: false, label: t("Report.OrderStaging.Email"), padding: '10px', field: 'email' },
            { id: "sms_phone", numeric: false, disablePadding: false, label: t("Report.OrderStaging.Phone"), padding: '10px', field: 'sms_phone' },
            { id: "prescription_number", numeric: false, disablePadding: false, label: t("Report.OrderStaging.PrescriptionNumber"), padding: '10px', field: 'prescription_number' },
            { id: "drug_name", numeric: false, disablePadding: false, label: t("Report.OrderStaging.DrugName"), padding: '10px', field: 'drug_name' },
            { id: "ndc", numeric: false, disablePadding: false, label: t("Report.OrderStaging.NDCCode"), padding: '10px', field: 'ndc' },
            { id: "prescription_txn_id", numeric: false, disablePadding: false, label: t("Report.OrderStaging.TransactionID"), padding: '10px', field: 'prescription_txn_id' },
            { id: "fillid", numeric: false, disablePadding: false, label: t("Report.OrderStaging.FillID"), padding: '10px', field: 'fillid' },
            { id: "prescription_id", numeric: false, disablePadding: false, label: t("Report.OrderStaging.PrescriptionID"), padding: '10px', field: 'prescription_id' },
            { id: "amount_due", numeric: false, disablePadding: false, label: t("Report.OrderStaging.AmountDue"), padding: '10px', field: 'amount_due' },
            { id: "dispensed_qty", numeric: false, disablePadding: false, label: t("Report.OrderStaging.DispensedQty"), padding: '10px', field: 'dispensed_qty' },
            { id: "expiry_date", numeric: false, disablePadding: false, label: t("Report.OrderStaging.ExpiryDate"), padding: '10px', field: 'expiry_date' },
            { id: "order_reciept_date", numeric: false, disablePadding: false, label: t("Report.OrderStaging.OrderReceiptDate"), padding: '10px', field: 'order_reciept_date' },
            { id: "client_identifier", numeric: false, disablePadding: false, label: t("Report.OrderStaging.ClientIdentifier"), padding: '10px', field: 'client_identifier' }
        ];

        return (
            <TableHead>
                <TableRow>
                    {rows.map(row => {
                        return (
                            <TableCell
                                key={row.id}
                                numeric={row.numeric}
                                padding={row.disablePadding ? "none" : "default"}
                                sortDirection={orderBy === row.id ? order : false}
                                style={{ padding: row.padding, color: 'rgba(0, 0, 0, 0.54)' }}
                            >
                                {["gender", "email", "sms_phone", "ndc", "amount_due", "dispensed_qty"].includes(row.id)
                                    ? (
                                        <TableSortLabel style={{ cursor: "text" }}>{row.label}</TableSortLabel>
                                    ) : (
                                        <Tooltip
                                            title={t("Global.Label.Filter.Sort")}
                                            placement={row.numeric ? "bottom-end" : "bottom-start"}
                                            enterDelay={300}
                                        >
                                            <TableSortLabel
                                                active={orderBy === row.field && sortId === row.id}
                                                direction={order}
                                                onClick={this.createSortHandler(row.id, row.field)}
                                            >
                                                {row.label}
                                            </TableSortLabel>
                                        </Tooltip>
                                    )
                                }
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    sortId: PropTypes.string.isRequired
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

const styles = theme => ({
    root: {
        width: "100%",
    },
    table: {
        minWidth: 1020
    },
    tableWrapper: {
        overflowX: "auto"
    },
    dob: {
        paddingTop: '25px',
    },
    headerdiv: {
        paddingLeft: '15%',
        paddingTop: '10'
    },
    padding10px: {
        padding: '10px'
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        maxWidth: 390,
    },
    logoWrapper:
    {
        position: 'absolute',
        width: '89%',
        height: '70%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'rgba(255,255,255,0.5)',
        zIndex: '7869'
    },
    spinner: {
        position: 'absolute',
        background: 'rgba(255,255,255,.4)',
        width: '100%',
        height: '100%',
        zIndex: '9999',
        top: 0,
        left: 0,
    },
    spinnerImage: {
        top: 'calc(50% - 32.5px)',
        left: 'calc(50% - 65px)',
        position: 'absolute',
        width: '130px',
        userSelect: 'none'
    },
    hidden: {
        display: 'none'
    },
    rowheight: {
        height: '35px'
    }
});

const __reportDefaultDates = getDefaultDateRange();

let OrderViewFilterObj = {
    searchtext: '',
    fromdate: formatFromDateForAPI(__reportDefaultDates.fromDate),
    todate: formatToDateForAPI(__reportDefaultDates.toDate),
    pageNo: 0,
    pageSize: 10,
    sortOrder: 'desc',
    sortColumn: 'order_timestamp',
    tableName: ''
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class EnhancedTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            order: "desc",
            dob: '',
            orderBy: "order_timestamp",
            page: 0,
            rowsPerPage: 10,
            searchtext: '',
            store_id: [],
            box_id: [],
            fromdate: null,
            todate: null,
            dateRangePreset: 'last7days',
            isOpen: false,
            stores: [],
            boxes: [],
            boxvalues: [],
            accountValues: [],
            nstores: [],
            nboxes: [],
            chipstores: [],
            chipboxes: [],
            loader: false,
            selectedObject: null,
            isDataEmpty: true,
            selectedTab: 0,
            tempThresholds: [],
            totalRecords: 0,
            locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale
        };
        this.debouceTimeout = null;
    }

    refreshGrid = () => {
        if (!this.gridApi) return;
        if (typeof this.gridApi.refreshServerSideStore === "function") {
            this.gridApi.refreshServerSideStore({ purge: true });
        } else if (typeof this.gridApi.refreshServerSide === "function") {
            this.gridApi.refreshServerSide({ purge: true });
        }
    };

    getRowId = (params) => {
        const d = params.data || {};
        if (d.__ssrmId) return String(d.__ssrmId);
        return [
            d.prescription_txn_id,
            d.order_id,
            d.prescription_id,
            d.fillid,
            d.order_timestamp,
            d.patient_id,
        ]
            .filter((v) => v != null && String(v).trim() !== '')
            .join('|') || `row-${Math.random().toString(36).slice(2)}`;
    };

    onPaginationChanged = (params) => {
        if (!params.api) return;
        const newPageSize = params.api.paginationGetPageSize();
        if (newPageSize && OrderViewFilterObj.pageSize !== newPageSize) {
            OrderViewFilterObj.pageSize = newPageSize;
        }
    };

    onGridReady = (params) => {
        this.gridApi = params.api;
        this._agFilterBody = OrderViewFilterObj;
        const datasource = createServerSideDatasource({
            sortMap: PHARMACY_REPORT_SORT_MAP,
            filterBody: OrderViewFilterObj,
            applyFilterModel: (body, filterModel) => {
                applyReportFilterModel(body, filterModel, {
                    dateColIds: ['order_timestamp'],
                });
            },
            pageZeroBased: true,
            getPageSize: () => OrderViewFilterObj.pageSize || 10,
            fetchPage: (body) =>
                fetch(process.env.REACT_APP_BASEURL + 'all/orders', {
                    method: 'post',
                    withCredentials: true,
                    headers: {
                        Authorization:
                            'Bearer ' +
                            JSON.parse(sessionStorage.getItem('user')).signInUserSession
                                .idToken.jwtToken,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        ...body,
                        fromdate: body.fromdate || '',
                        todate: body.todate || '',
                        searchtext: body.searchtext || '',
                    }),
                }).then((r) => r.json()),
            onSuccess: (results, total) => {
                setTimeout(() => {
                    this.setState({
                        data: results,
                        totalRecords: total,
                        loader: false,
                        isDataEmpty: !results || results.length === 0,
                    });
                }, 0);
            },
            onError: () => this.setState({ loader: false }),
        });
        attachReportServerSideDatasource(
            params,
            datasource,
            OrderViewFilterObj,
            'order_timestamp'
        );
    };

    componentDidMount() {
        this.setState({ loader: true });
        // Set default date range (last 7 days)
        const defaultDates = getDefaultDateRange();
        this.setState({
            fromdate: defaultDates.fromDate,
            todate: defaultDates.toDate,
            dateRangePreset: 'last7days'
        });

        // Mutate in place — SSRM datasource holds a reference to this object.
        OrderViewFilterObj.searchtext = '';
        OrderViewFilterObj.fromdate = formatFromDateForAPI(defaultDates.fromDate);
        OrderViewFilterObj.todate = formatToDateForAPI(defaultDates.toDate);
        OrderViewFilterObj.pageNo = 0;
        OrderViewFilterObj.pageSize = 10;
        OrderViewFilterObj.sortOrder = 'desc';
        OrderViewFilterObj.sortColumn = 'order_timestamp';
        OrderViewFilterObj.tableName = '';
        this.fetchSuggestions();
    }

    convertToTimeZone = (requestDate) => {
        const currentUserLang = localStorage.getItem('i18nextLng');
        let zone;
        zone = sessionStorage.getItem('timeZone');
        const date = moment(new Date(requestDate));
        if (['null', null, 'undefined', undefined].includes(zone)) {
            zone = defaultZone;
        }
        return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
    }

    gettingOnSortTableName = (field) => {
        let tablename = '';
        if (['order_id', 'order_timestamp', 'store_ncpdp', 'patient_id', 'first_name', 'last_name', 'dob',
            'prescription_number', 'drug_name', 'prescription_txn_id', 'fillid',
            'prescription_id', 'expiry_date', 'order_reciept_date', 'client_identifier'].includes(field)) {
            tablename = 'order_staging';
        }
        return tablename;
    }

    handleRequestSort = (event, property, field) => {
        const orderBy = property;
        let order = "desc";
        if (this.state.order === "desc") {
            order = "asc";
        }
        this.setState({ order, orderBy, sortId: property });
        OrderViewFilterObj.sortOrder = order;
        OrderViewFilterObj.sortColumn = field;
        OrderViewFilterObj.tableName = this.gettingOnSortTableName(orderBy);
        
        if (this.state.data && this.state.data.length > 0) {
            this.BindGrid();
        }
    };

    handleChangePage = (event, page) => {
        event && event.preventDefault();
        
        OrderViewFilterObj.pageNo = page;
        if (this.state.data && this.state.data.length > 0) {
            this.BindGrid();
        }
    };

    handleChangeRowsPerPage = event => {
        
        OrderViewFilterObj.pageNo = 0;
        OrderViewFilterObj.pageSize = event.target.value;
        if (this.state.data && this.state.data.length > 0) {
            this.BindGrid();
        }
    };

    //Search Text Box change event
    onSearchChange = (event) => {
        this.debouceTimeout && clearInterval(this.debouceTimeout);
        const searchString = event.target.value;
        this.setState({ searchtext: searchString && searchString });
        OrderViewFilterObj.pageNo = 0;
        OrderViewFilterObj.sortOrder = 'desc';
        OrderViewFilterObj.sortColumn = 'order_timestamp';
        OrderViewFilterObj.tableName = '';
        OrderViewFilterObj.searchtext = searchString;
        this.debouceTimeout = setTimeout(() => {
            this.BindGrid();
        }, 1000)
    }

    onFromDateSelect = date => {
        const dateObj = date ? moment(date) : null;
        this.setState({ fromdate: dateObj, dateRangePreset: '' });
        OrderViewFilterObj.pageNo = 0;
        OrderViewFilterObj.sortOrder = 'desc';
        OrderViewFilterObj.sortColumn = 'order_timestamp';
        OrderViewFilterObj.tableName = '';
        OrderViewFilterObj.fromdate = formatFromDateForAPI(dateObj);
        this.BindGrid();
    };

    onToDateSelect = date => {
        const dateObj = date ? moment(date) : null;
        this.setState({ todate: dateObj, dateRangePreset: '' });
        OrderViewFilterObj.pageNo = 0;
        OrderViewFilterObj.sortOrder = 'desc';
        OrderViewFilterObj.sortColumn = 'order_timestamp';
        OrderViewFilterObj.tableName = '';
        OrderViewFilterObj.todate = formatToDateForAPI(dateObj);
        this.BindGrid();
    };

    handleBlurfrom = (value, date) => {
        const dateObj = date ? moment(date) : null;
        this.setState({
            fromdate: dateObj,
            dateRangePreset: ''
        });
        OrderViewFilterObj.pageNo = 0;
        OrderViewFilterObj.sortOrder = 'desc';
        OrderViewFilterObj.sortColumn = 'order_timestamp';
        OrderViewFilterObj.tableName = '';
        OrderViewFilterObj.fromdate = formatFromDateForAPI(dateObj);
        this.BindGrid();
    }

    handleBlurtodate = (value, date) => {
        const dateObj = date ? moment(date) : null;
        this.setState({
            todate: dateObj,
            dateRangePreset: ''
        });
        OrderViewFilterObj.pageNo = 0;
        OrderViewFilterObj.sortOrder = 'desc';
        OrderViewFilterObj.sortColumn = 'order_timestamp';
        OrderViewFilterObj.tableName = '';
        OrderViewFilterObj.todate = formatToDateForAPI(dateObj);
        this.BindGrid();
    }
    
    handleDateRangePresetChange = (event) => {
        const preset = event.target.value;
        if (!preset) return;
        
        const dateRange = getDateRangeByPreset(preset);
        this.setState({
            fromdate: dateRange.fromDate,
            todate: dateRange.toDate,
            dateRangePreset: preset
        });
        
        OrderViewFilterObj.pageNo = 0;
        OrderViewFilterObj.sortOrder = 'desc';
        OrderViewFilterObj.sortColumn = 'order_timestamp';
        OrderViewFilterObj.tableName = '';
        OrderViewFilterObj.fromdate = formatFromDateForAPI(dateRange.fromDate);
        OrderViewFilterObj.todate = formatToDateForAPI(dateRange.toDate);
        this.BindGrid();
    };

    BindGrid = () => {
        if (this.gridApi) {
            this.refreshGrid();
            return;
        }
        // SSRM datasource is attached in onGridReady; avoid a parallel
        // legacy fetch/setState race that leaves the grid empty.
        this.setState({ loader: false });
    };

    fetchSuggestions = async () => {
        try {
          const result = fetch(`${process.env.REACT_APP_BASEURL}groups/search`, {
            method: "GET",
            withCredentials: true,
            headers: {
              Authorization:
                "Bearer " +
                JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
                  .jwtToken,
              "Content-Type": "application/json",
            },
          }
          );
          result
            .then((result) => {
              result.json().then((resLocation) => {
                this.setState({ groups: resLocation && resLocation.data })
              })
            })
        } catch (error) {
          console.error("Error fetching groups:", error);
        }
      };

    render() {
        const {classes, t} = this.props;
        
        return (
            <Paper id="react-no-print" className={classes.root}>
                {
                    this.state.loader ?
                        <div className={classes.spinner}>
                            <img className={classes.spinnerImage} src={spinner} alt="loading" />
                        </div> :
                        null
                }
                <div id="react-no-print" className={classes.tableWrapper}>
                    <ILocalAGGrid
                        columnDefs={[
                            withDateColumnFilter({
                                field: 'order_timestamp',
                                headerName: t("Report.OrderStaging.OrderTimestamp"),
                                colId: 'order_timestamp',
                                valueFormatter: (p) => p.value ? this.convertToTimeZone(p.value) : '',
                            }),
                            { field: 'order_id', headerName: t("Report.OrderStaging.OrderID"), colId: 'order_id' },
                            { field: 'store_ncpdp', headerName: t("Report.OrderStaging.StoreNCPDP"), colId: 'store_ncpdp' },
                            { field: 'patient_id', headerName: t("Report.OrderStaging.PatientID"), colId: 'patient_id' },
                            { field: 'first_name', headerName: t("Report.OrderStaging.FirstName"), colId: 'first_name' },
                            { field: 'last_name', headerName: t('Report.OrderStaging.LastName'), colId: 'last_name' },
                            { field: 'gender', headerName: t("Report.OrderStaging.Gender"), colId: 'gender' },
                            { field: 'dob', headerName: t("Report.OrderStaging.DOB"), colId: 'dob' },
                            { field: 'email', headerName: t("Report.OrderStaging.Email"), colId: 'email' },
                            { field: 'sms_phone', headerName: t("Report.OrderStaging.Phone"), colId: 'sms_phone' },
                            { field: 'prescription_number', headerName: t("Report.OrderStaging.PrescriptionNumber"), colId: 'prescription_number' },
                            { field: 'drug_name', headerName: t("Report.OrderStaging.DrugName"), colId: 'drug_name' },
                            { field: 'ndc', headerName: t("Report.OrderStaging.NDCCode"), colId: 'ndc' },
                            { field: 'prescription_txn_id', headerName: t("Report.OrderStaging.TransactionID"), colId: 'prescription_txn_id' },
                            { field: 'fillid', headerName: t("Report.OrderStaging.FillID"), colId: 'fillid' },
                            { field: 'prescription_id', headerName: t("Report.OrderStaging.PrescriptionID"), colId: 'prescription_id' },
                            {
                                field: 'amount_due',
                                headerName: t("Report.OrderStaging.AmountDue"),
                                colId: 'amount_due',
                                valueFormatter: (p) => p.value ? '$' + parseFloat(p.value).toFixed(2) : '$0.00',
                            },
                            { field: 'dispensed_qty', headerName: t("Report.OrderStaging.DispensedQty"), colId: 'dispensed_qty' },
                            {
                                field: 'expiry_date',
                                headerName: t("Report.OrderStaging.ExpiryDate"),
                                colId: 'expiry_date',
                                valueFormatter: (p) => p.value ? this.convertToTimeZone(p.value) : '',
                            },
                            {
                                field: 'order_reciept_date',
                                headerName: t("Report.OrderStaging.OrderReceiptDate"),
                                colId: 'order_reciept_date',
                                valueFormatter: (p) => p.value ? this.convertToTimeZone(p.value) : '',
                            },
                            { field: 'client_identifier', headerName: t("Report.OrderStaging.ClientIdentifier"), colId: 'client_identifier' },
                        ]}
                        defaultColDef={getDefaultColDef()}
                        rowModelType="serverSide"
                        cacheBlockSize={OrderViewFilterObj.pageSize || 10}
                        paginationPageSize={OrderViewFilterObj.pageSize || 10}
                        paginationPageSizeSelector={[10, 20, 25]}
                        rowHeight={40}
                        getRowId={this.getRowId}
                        onGridReady={this.onGridReady}
                        onPaginationChanged={this.onPaginationChanged}
                    />
                </div>
            </Paper>
        );
    }
}

EnhancedTable.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/reports/orders-view/index.js